const legal = {
  infoPageLayout: {
    manageCookies: "Gerir os meus cookies",
  },
  terms: {
    title: "Condições de utilização",
    subtitle: "Regras gerais aplicáveis ao acesso e à utilização da Qubiq.",
    sections: [
      {
        title: "1. Objeto",
        body: "{{brandName}} é uma plataforma interativa de streaming de vídeo que permite ver conteúdos, interagir com jogos integrados e utilizar funcionalidades comunitárias.",
      },
      {
        title: "2. Acesso ao serviço",
        body: "O acesso a determinadas funcionalidades da Qubiq requer a criação de uma conta. O utilizador compromete-se a fornecer informações exatas, a manter a confidencialidade dos seus acessos e a não desviar o serviço do seu uso normal.",
      },
      {
        title: "3. Conteúdos e comportamentos proibidos",
        body: "É proibido publicar, difundir ou retransmitir conteúdos ilícitos, fraudulentos, odiosos, violentos, enganadores, pornográficos não autorizados, que violem direitos de terceiros ou contrariem as regras de moderação da Qubiq.",
      },
      {
        title: "4. Propriedade intelectual",
        body: "Os elementos da plataforma Qubiq, o seu design, as suas marcas, os seus visuais, as suas interfaces e os seus desenvolvimentos permanecem protegidos. Salvo autorização expressa, não podem ser copiados, reproduzidos, extraídos nem reutilizados para fins comerciais.",
      },
      {
        title: "5. Suspensão ou eliminação de conta",
        body: "A Qubiq pode restringir, suspender ou eliminar o acesso à totalidade ou a parte do serviço em caso de incumprimento destas condições, tentativa de fraude, comportamento prejudicial para a comunidade ou risco de segurança.",
      },
      {
        title: "6. Contacto",
        body: "Para qualquer questão sobre estas condições, podes escrever para {{contactEmail}}.",
      },
    ],
  },
  privacy: {
    title: "Política de privacidade",
    subtitle: "Como a Qubiq trata os dados pessoais e como exercer os teus direitos.",
    sections: [
      {
        title: "Responsável pelo tratamento",
        body: "{{companyName}}, acessível através de {{websiteUrl}}, atua na qualidade de responsável pelo tratamento dos dados processados no âmbito da plataforma {{brandName}}.",
      },
      {
        title: "Dados tratados",
        body: "Consoante a tua utilização do serviço, podemos tratar: identidade da conta, email, nome de utilizador, imagem de perfil, histórico de utilização, interações comunitárias, preferências de consentimento, informações técnicas de navegação e dados ligados à wallet ou aos ganhos quando essas funcionalidades são utilizadas.",
      },
      {
        title: "Finalidades e bases legais",
        body: "- Fornecer o serviço, a reprodução de vídeo, os jogos, o perfil e as notificações: execução do serviço.\n- Proteger a plataforma, combater a fraude e moderar conteúdos: interesse legítimo e obrigações legais.\n- Gerir pedidos de suporte e direitos RGPD: obrigação legal e interesse legítimo.\n- Medir a audiência com Google Analytics: consentimento.",
      },
      {
        title: "Destinatários",
        body: "Os dados são acessíveis, conforme a necessidade, às equipas autorizadas da Qubiq e aos seus prestadores técnicos. A Qubiq utiliza nomeadamente o Clerk para autenticação e o Google Analytics para medição de audiência quando o aceitas.",
      },
      {
        title: "Prazos de conservação",
        body: "Os prazos variam consoante a finalidade:\n- conta de utilizador: durante a existência da conta e depois conforme as obrigações legais aplicáveis;\n- registos técnicos e de segurança: o período limitado necessário para segurança e diagnóstico;\n- preferências de cookies: 6 meses;\n- dados de audiência: segundo a configuração do Google Analytics e a política de conservação adotada pela Qubiq.",
      },
      {
        title: "Transferências para fora da UE",
        body: "Alguns prestadores podem tratar dados fora da União Europeia. Nesse caso, a Qubiq implementa as garantias adequadas exigidas pelo RGPD, nomeadamente cláusulas contratuais apropriadas quando necessário.",
      },
      {
        title: "Os teus direitos",
        body: "Dispões, consoante o caso, dos direitos de acesso, retificação, apagamento, oposição, limitação, portabilidade e do direito de retirar o teu consentimento a qualquer momento para os tratamentos baseados nesse consentimento. Podes igualmente apresentar reclamação junto da CNIL.",
      },
      {
        title: "Contacto de dados pessoais",
        body: "Para qualquer pedido relativo aos teus dados pessoais: {{privacyEmail}}.",
      },
    ],
  },
  legalNotice: {
    title: "Informação legal",
    subtitle: "Informações sobre o editor do serviço e o alojamento do site.",
    items: {
      editorLabel: "Editor do site",
      legalFormLabel: "Forma jurídica",
      legalFormValue: "{{legalForm}} — capital social: {{capital}}",
      registrationLabel: "Registo",
      registrationValue: "Registo Comercial de {{registrationCity}} {{registrationNumber}}",
      registrationDateLabel: "Data de registo",
      euidLabel: "EUID",
      vatLabel: "Número de IVA intracomunitário",
      addressLabel: "Morada",
      activitiesLabel: "Atividades principais",
      publicationDirectorLabel: "Diretor da publicação",
      contactLabel: "Contacto",
      hostingLabel: "Alojamento",
      hostingValue: "{{hostingCompany}}\n{{hostingAddress}}",
      intellectualPropertyLabel: "Propriedade intelectual",
      intellectualPropertyValue:
        "Os conteúdos, interfaces, marcas, visuais e desenvolvimentos do serviço Qubiq estão protegidos. Qualquer reprodução ou exploração não autorizada é proibida.",
    },
  },
  cookies: {
    title: "Política de cookies",
    subtitle: "Informações sobre os rastreadores utilizados pela Qubiq e sobre a gestão das tuas escolhas.",
    sections: [
      {
        title: "Princípio",
        body: "A Qubiq utiliza cookies e outros rastreadores necessários ao funcionamento do serviço. Os rastreadores de medição de audiência estão desativados por defeito e só são ativados após o teu consentimento explícito.",
      },
      {
        title: "Categorias utilizadas",
        body: "- Cookies necessários: segurança, login, estabilidade da sessão, funcionamento essencial.\n- Medição de audiência: Google Analytics 4, com consentimento.\n- Marketing: por enquanto não está ativado na Qubiq.",
      },
      {
        title: "Durações e terceiros",
        body: "- Preferência de consentimento da Qubiq: armazenada localmente sob a chave {{consentStorageKey}} durante 6 meses.\n- {{analyticsProvider}}: cookies de medição de audiência, duração predefinida anunciada pela Google: até 2 anos, sujeita às limitações do navegador e à configuração adotada pela Qubiq.\n- Prestador terceiro envolvido na medição de audiência: Google.",
      },
      {
        title: "Google Analytics",
        body: "{{analyticsProvider}} não é carregado antes do teu consentimento. Quando o aceitas, a Qubiq utiliza a medição de audiência para compreender melhor a utilização do serviço, melhorar o desempenho e identificar as grandes tendências de navegação.",
      },
      {
        title: "Retirar ou alterar o consentimento",
        body: "Podes alterar as tuas escolhas a qualquer momento através do botão “Gerir os meus cookies” disponível nesta página, nas ligações informativas do site e no menu de perfil.",
      },
      {
        title: "Lembrete regulamentar",
        body: "Na Qubiq, recusar cookies de medição de audiência é tão simples como aceitá-los. O serviço principal continua acessível sem ativar o Google Analytics.",
      },
    ],
  },
  moderation: {
    title: "Regras de moderação da Qubiq",
    subtitle: "As regras da Qubiq Republic para proteger a comunidade, os criadores e os jogadores.",
    sections: [
      {
        title: "1. Respeito pela comunidade",
        body: "Não são permitidos insultos, ataques direcionados, humilhações, ameaças, campanhas de assédio ou comportamentos destinados a prejudicar outro utilizador, criador ou moderador.",
      },
      {
        title: "2. Conteúdos ilegais ou perigosos",
        body: "São proibidos: apologia de crimes, terrorismo, conteúdos pedocriminais, doxxing, divulgação não autorizada de dados pessoais, burlas, fraude, hacking, incitação ao ódio ou qualquer publicação contrária à lei.",
      },
      {
        title: "3. Engano, spam e manipulação",
        body: "É proibido fazer spam, manipular artificialmente a audiência, publicar concursos falsos ou enganar os utilizadores sobre ganhos, jogos, qubs ou condições de participação.",
      },
      {
        title: "4. Proteção de menores",
        body: "Conteúdos sexualizados, chocantes, humilhantes ou perigosos para menores são proibidos. Os utilizadores devem evitar qualquer encenação inadequada ou exploração de públicos vulneráveis.",
      },
      {
        title: "5. Jogos e fair play",
        body: "Qualquer tentativa de batota, automatização abusiva, contorno das regras de run, duplicação de ganhos, exploração de bugs ou alteração deliberada da experiência de jogo pode levar à suspensão ou eliminação da conta.",
      },
      {
        title: "6. Direitos de terceiros",
        body: "Deves dispor dos direitos necessários para publicar um conteúdo na Qubiq. Violações de direitos de autor, imagem, privacidade ou marcas de terceiros podem levar a moderação imediata.",
      },
      {
        title: "7. Medidas possíveis",
        body: "A Qubiq pode remover um conteúdo, limitar determinadas funcionalidades, bloquear uma partilha, suspender uma conta, retirar vantagens ligadas à plataforma ou comunicar os factos às autoridades quando a situação o justificar.",
      },
      {
        title: "8. Espírito Qubiq",
        body: "A Qubiq é uma plataforma interativa: pode-se debater, jogar, atuar e partilhar. Mas a experiência deve continuar saudável, leal, clara e respeitosa. Se um conteúdo quebrar esse equilíbrio, pode ser moderado.",
      },
    ],
  },
};

export default legal;
